import { enableXrayIcon } from '../state/ui-store';

export const enableXrayBttn = () => enableXrayIcon();
